import {inject} from '@angular/core';
import {CanActivateFn, CanMatchFn, Router} from '@angular/router';
import {EmitterService} from "@ngxs-labs/emitter";
import {DataState} from "../store/data.state";
import * as Sentry from "@sentry/angular";


export function checkIfFlowIdExistInUrlGuard(): CanActivateFn | CanMatchFn {
  return () => {
    const emitterService: EmitterService = inject(EmitterService);
    const router: Router = inject(Router);
    const flowId = router.getCurrentNavigation()?.extractedUrl.queryParamMap.get('flowId');
    if (flowId) {
      emitterService.action<string>(DataState.saveFlowId).emit(flowId);
      return true;
    } else {
      Sentry.captureException(new Error('Required query parameter flowId was null or undefined.'));
      emitterService.action<null>(DataState.saveFlowId).emit(null);
      router.navigate(['/error']);
      return false;
    }
  };
}
